export default __webpack_public_path__ + "static/media/bota1.fa1b2d42.png";